import React from 'react';
import { useApi } from '../../api-provider';
import { useConfiguration } from '../../context/configuration-context/use-configuration';
import { getModalEffect } from '../../../common/store/comments/comments-selectors';
import { unreachable } from '../../../ts-utils';
import { useModal, PendingModeratedCommentModal, BlockedModeratedCommentModal } from '../modals';
export const useModalEffect = () => {
    const { resourceId } = useConfiguration();
    const { modalEffect } = useApi((state) => ({
        modalEffect: getModalEffect(state, resourceId),
    }));
    const showModal = useModal();
    React.useEffect(() => {
        if (!modalEffect) {
            return;
        }
        switch (modalEffect.type) {
            case 'pending-comment':
                showModal((close) => React.createElement(PendingModeratedCommentModal, { onClose: close }));
                break;
            case 'blocked-comment':
                showModal((close) => React.createElement(BlockedModeratedCommentModal, { onClose: close }));
                break;
            case undefined:
                break;
            default:
                throw unreachable(modalEffect.type);
        }
    }, [modalEffect?.timestamp, showModal]);
};
//# sourceMappingURL=use-modal-effect.js.map